/**
 * Value text colors for nutrition totals grids (meal detail, scanned food detail, etc.).
 * Matches Mealpage macro ring semantics: protein=blue, carbs=emerald, fat=amber, fiber=purple, glycemic=violet.
 */
export const MEAL_DETAIL_MACRO_CLASS = {
  calories: "text-foreground",
  protein: "text-blue-600 dark:text-blue-400",
  carbs: "text-emerald-600 dark:text-emerald-400",
  fat: "text-amber-600 dark:text-amber-400",
  sugar: "text-red-600 dark:text-red-400",
  fiber: "text-purple-600 dark:text-purple-400",
  satFat: "text-orange-700 dark:text-orange-500",
  transFat: "text-slate-600 dark:text-slate-400",
  netCarbs: "text-teal-700 dark:text-teal-400",
  glycemic: "text-violet-600 dark:text-violet-400",
  sodium: "text-purple-600 dark:text-purple-400",
  cholesterol: "text-foreground",
} as const;
